import axios from 'axios';

interface Urlprops {
  url: string; // URLパラメータで取得されるリセットトークン
}
/**
 * パスワード再設定用URLが有効かどうか、
 * 
 * 既に再設定が完了しているかチェック
 * @returns 
 */

//　パスワード再設定用URLが有効かどうかを確認する関数
export async function checkPasswordUrl(props:Urlprops): Promise<any> {
    try{
        const response = await axios.get(process.env.REACT_APP_PATH + `/login/mail/reset`,      // サーバーにURLを渡して再設定が完了しているかチェック
            {
                params:{url:props.url},
            });
            return JSON.parse(JSON.stringify(response.data[0]));
        }catch(error){
            throw error;
    }
}
   

